import { Box, Button, Container, Link, Stack, TextField, Typography } from "@mui/material"
import { SOCIAL_LINKS } from "./Layout/SocialLinks"
import { useTranslations } from "next-intl"
import { enqueueSnackbar } from "notistack"
import { useLogger } from '@/lib/axiom/client'
import { memo, useState } from "react"
import { getCookie } from "@/utils/Utils"

const FeedbackConnect: React.FC = () => {
    const t1 = useTranslations('DOWNLOADS_PAGE')
    const [suggestion, setSuggestion] = useState('')
    const [contactInfo, setContactInfo] = useState('')
    const logger = useLogger().with({ userId: getCookie('mbm-user-id') })

    const handleSuggestionSubmit = () => {
        if (!contactInfo.trim()) {
            enqueueSnackbar(t1('SUGGESTION_EMAIL_PLACEHOLDER'), {
                variant: 'error',
                TransitionProps: { direction: 'up' },
            })
            return
        }

        if (suggestion.trim()) {
            logger.info('User submitted suggestion', {
                suggestion: suggestion.trim(),
                contactInfo: contactInfo.trim()
            })
            setSuggestion('')
            setContactInfo('')
            enqueueSnackbar(t1('SUGGESTION_SUBMITTED'), {
                variant: 'success',
                TransitionProps: { direction: 'up' },
            })
        }
    }

    return (
        <Container maxWidth="md" sx={{ my: 6, textAlign: 'center' }}>
            <Box sx={{ mb: 4, maxWidth: 600, mx: 'auto' }}>
                <Typography
                    variant="body1"
                    sx={{
                        color: "text.secondary",
                        mb: 2
                    }}>
                    {t1('SUGGESTION_PROMPT')}
                </Typography>

                <TextField
                    fullWidth
                    placeholder={t1('SUGGESTION_EMAIL_PLACEHOLDER')}
                    value={contactInfo}
                    onChange={(e) => setContactInfo(e.target.value)}
                    sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(255,255,255,0.8)',
                        },
                    }}
                    required
                />

                <TextField
                    multiline
                    rows={3}
                    fullWidth
                    placeholder={t1('SUGGESTION_PLACEHOLDER')}
                    value={suggestion}
                    onChange={(e) => setSuggestion(e.target.value)}
                    slotProps={{ htmlInput: { maxLength: 200 } }}
                    sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: 'rgba(255,255,255,0.8)',
                        },
                    }}
                    helperText={`${suggestion.length}/200`}
                />
                <Button
                    variant="contained"
                    onClick={handleSuggestionSubmit}
                    disabled={!suggestion.trim() || !contactInfo.trim()}
                    sx={{
                        textTransform: 'none',
                        px: 4,
                    }}
                >
                    {t1('SUBMIT_SUGGESTION')}
                </Button>
            </Box>
            <Typography
                variant="body2"
                sx={{
                    color: "text.secondary",
                    mb: 3
                }}>
                {t1('HELP_TEXT')}{' '}
                <Link
                    href="mailto:contact@marriagebiodatamaker.app"
                    sx={{
                        color: 'primary.main',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                    }}
                >
                    contact@marriagebiodatamaker.app
                </Link>
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: "text.secondary",
                    mb: 2
                }}>
                {t1('SOCIAL_MEDIA_TEXT')}
            </Typography>
            <Stack
                direction="row"
                sx={{
                    gap: 2,
                    justifyContent: "center",

                    '& a': {
                        color: 'text.secondary',
                        transition: 'color 0.2s',
                        '&:hover': { color: 'primary.main' },
                    }
                }}>
                {SOCIAL_LINKS.map((socialLink) => (
                    <Link key={socialLink.href} href={socialLink.href} target="_blank">
                        <socialLink.icon />
                    </Link>
                ))}
            </Stack>
        </Container>
    );
}

export default memo(FeedbackConnect)